import React from 'react'

import styles from './utils.module.css'

export function highlight(highlightString, value) {
    const stringValue = typeof value === 'number' ? value.toString() : value
    if (highlightString && stringValue) {
        const startAt = stringValue.toLowerCase().indexOf(highlightString.toLowerCase())
        if (startAt >= 0) {
            const start = stringValue.substring(0, startAt)
            const boldString = stringValue.substring(startAt, startAt + highlightString.length)
            const end = stringValue.substring(startAt + highlightString.length, stringValue.length)
            return (
                <span className="t3sel-highlight-string">
                    {start}
                    <span className={styles['highlight']}>{boldString}</span>
                    {end}
                </span>
            )
        } else {
            return stringValue
        }
    } else {
        return stringValue
    }
}
